export const base_url = process.env.REACT_APP_BASE_URL;
export const socket_url = process.env.REACT_APP_SOCKET_URL;

// export const base_url = "https://sandbox-api.ibizaonly.everestapps.io/api/v1/admin/";
// export const socket_url = "https://sandbox-api.ibizaonly.everestapps.io";

// export const base_url = process.env.REACT_APP_BASE_URL ?? "https://sandbox-api.ibizaonly.everestapps.io/api/v1/admin/";
// export const socket_url = process.env.REACT_APP_SOCKET_URL ?? "https://sandbox-api.ibizaonly.everestapps.io";
